export default __webpack_public_path__ + "static/media/car logo.5b424d0c.png";